import React from 'react';
import { useTrackingOp } from "../../../../contexts/TrackingOpContext";
import Icon, { ICON_NAME } from "../../../Icon";
import Header from "../../_components/Header";
import StepControl from "../../_components/StepControl";
import TabControl from "../../_components/TabControl";
import ActivityLogs from '../../ActivitiesLog/ActivityLogs/ActivityLogs';
import stylesOp from "../style.module.scss";

const Support: React.FC = () => {
    const [data] = useTrackingOp(state => state.op);

    if (!data) return null;

    return <>
        <Header icon={<Icon icon={ICON_NAME.SUPPORT_OP} />} />
        <TabControl>
            {[
                <div key="step" className={stylesOp['operation-info']}>
                    <div className={stylesOp['operation-content']}>
                        <StepControl />
                    </div>
                </div>,
                <ActivityLogs key="activity-log" data={data} />
            ]}
        </TabControl>

    </>;
};

export default Support;